import CloseIcon from '@mui/icons-material/Close'
import _ from 'lodash'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './ProductFilterMobileModal.module.scss'
import { ActiveFiltersInterface, ProductFiltersInterface } from '../../../../interfaces/FiltersInterface'
import { hasActiveFilters } from '../../../../utils/productFilter'
import LoadingSpinner, { Color } from '../../../LoadingSpinner/LoadingSpinner'
import Modal, { ModalButton, ModalContent, ModalFooter, ModalHeader } from '../../../Modal/Modal'
import ProductFilterList from '../../ProductFilterList/ProductFilterList'

interface Props {
  open: boolean
  filters: ProductFiltersInterface
  activeFilters: ActiveFiltersInterface
  loading: boolean
  itemsCounter: number
  onFlatAttributeChange: (name: string, valueId: number | string, checked: boolean) => void
  onAttributeChange: (attributeId: number, valueId: number, checked: boolean) => void
  onRangeChanged: (attributeId: string, minValue: string | null, maxValue: string | null, extra?: object) => void
  clearFilters: () => void
  onClose: () => void
}

const ProductFilterMobileModal: React.FC<Props> = (props: Props) => {
  const closeButtonLabel = hasActiveFilters(props.activeFilters) ? (
    <FormattedMessage
      id="ProductFilter.Modal.ShowResults"
      defaultMessage="Show {itemsCounter, number} {itemsCounter, plural, one {result} other {results}}"
      values={{ itemsCounter: props.itemsCounter }}
    />
  ) : (
    <FormattedMessage id="ProductFilter.Modal.Apply" defaultMessage="Apply" />
  )

  return (
    <Modal open={props.open} onClose={props.onClose}>
      <ModalHeader>
        <ModalButton
          leftIcon={<CloseIcon onClick={props.onClose} />}
          classes={{ root: styles['product-filter-mobile-modal__modal_header__button'] }}
        >
          <FormattedMessage id="ProductFilter.Modal.Header" defaultMessage="Filters" />
        </ModalButton>
      </ModalHeader>
      <ModalContent className={styles['product-filter-mobile-modal__modal_content']}>
        <ProductFilterList
          filters={props.filters}
          activeFilters={props.activeFilters}
          onFlatAttributeChange={props.onFlatAttributeChange}
          onAttributeChange={props.onAttributeChange}
          onRangeChanged={props.onRangeChanged}
        />
      </ModalContent>
      <ModalFooter>
        <ModalButton onClick={props.clearFilters}>
          <FormattedMessage id="ProductFilter.Modal.Clear" defaultMessage="Clear all" />
        </ModalButton>
        <ModalButton active onClick={props.loading ? undefined : props.onClose}>
          {props.loading ? <LoadingSpinner size={19} color={Color.Inherit} /> : closeButtonLabel}
        </ModalButton>
      </ModalFooter>
    </Modal>
  )
}

export default ProductFilterMobileModal
